<template>
  <MakerCartGuideLayout
    pageTitle="Maker Activity Lesson Flow"
    heroImage="/images/maker-cart-guide/rectangle-4690.png"
    previousUrl="/makercart/guide/3"
    nextUrl="/makercart/guide/5"
  >
    <div class="x-guide4-content">
      <div class="x-section-heading">
        <h2>General Maker Activity Lesson Structure</h2>
      </div>

      <div class="x-steps-container">
        <!-- Step 1 -->
        <div class="x-step-card">
          <div class="x-step-number">1</div>
          <div class="x-step-content">
            <h3 class="x-step-title">Hook</h3>
            <p class="x-step-text">
              ‘A Hook’ is the activity that builds context and piques interest.
              It could be a probing question or summary that helps students to
              reflect on their present knowledge and prepares them for the new
              knowledge.
            </p>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="x-step-card">
          <div class="x-step-number">2</div>
          <div class="x-step-content">
            <h3 class="x-step-title">Maker element</h3>
            <div class="x-step-text">
              <p>
                The ‘maker element’ can be described as an activity in one of
                the following ways:
              </p>
              <ol>
                <li>
                  Helps to discover a new concept through tinkering with
                  materials (Tinker to Discover approach) or
                </li>
                <li>
                  Builds on their existing subject knowledge through making to
                  cement or deepen their understanding (Make to Learn approach)
                  or
                </li>
              </ol>
              <p>
                Provides them with an opportunity to demonstrate their subject
                knowledge by working on a project, and applying what they have
                learned (Application Project approach)
              </p>
            </div>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="x-step-card">
          <div class="x-step-number">3</div>
          <div class="x-step-content">
            <h3 class="x-step-title">Sharing activity</h3>
            <p class="x-step-text">
              This is the ‘show and tell’ activity that helps students to
              present what they have created, share their learnings and take
              feedback from others.
            </p>
          </div>
        </div>

        <!-- Step 4 -->
        <div class="x-step-card">
          <div class="x-step-number">4</div>
          <div class="x-step-content">
            <h3 class="x-step-title">Reflection</h3>
            <p class="x-step-text">
              This helps learners to connect the concepts they have learned to
              practice. They bring focus back to the most important learning
              goals through the lesson.
            </p>
          </div>
        </div>

        <!-- Step 5 -->
        <div class="x-step-card">
          <div class="x-step-number">5</div>
          <div class="x-step-content">
            <h3 class="x-step-title">Exit ticket</h3>
            <p class="x-step-text">
              ‘Exit ticket’ helps educators assess informally how well learners
              have learned the topic.
            </p>
          </div>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped>
.x-guide4-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.x-section-heading {
  padding: 16px;
}

.x-section-heading h2 {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xl);
  line-height: 32px;
  color: var(--primary-blue);
  margin: 0;
}

.x-steps-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.x-step-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 16px;
  overflow: hidden;
}

/* For better overflow handling of huge numbers */
.x-step-number {
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translateY(-48%);
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: 290px;
  line-height: 310px;
  color: #f2f3fb;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.x-step-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.x-step-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xl);
  line-height: 32px;
  color: var(--primary-blue);
  margin: 0;
}

.x-step-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.08px;
  color: var(--primary-blue);
  margin: 0;
}

.x-step-text p {
  margin: 0 0 16px 0;
}
.x-step-text p:last-child {
  margin: 0;
}

.x-step-text ol {
  margin: 0 0 16px 24px;
  padding: 0;
}

.x-step-text li {
  margin: 0 0 8px 0;
}
.x-step-text li:last-child {
  margin: 0;
}
</style>
